import { render, staticRenderFns } from "./CompanyDocuments.vue?vue&type=template&id=54a040cc&"
import script from "./CompanyDocuments.vue?vue&type=script&lang=js&"
export * from "./CompanyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDocuments.vue?vue&type=style&index=0&id=54a040cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports